const ROOT = "giphy-player";
const INSERT_GIF_BUTTON = "insert-gif-button";
const INSERT_GIF_MODAL = "insert-gif-modal";
const INSERT_GIF_MODAL_GIF_SEARCH_INPUT = "insert-gif-modal-gif-search-input";
const INSERT_GIF_MODAL_STICKER_SEARCH_INPUT = "insert-gif-modal-sticker-search-input";
const INSERT_GIF_MODAL_GIF_ITEM = "insert-gif-modal-gif-item";
const INSERT_GIF_MODAL_STICKER_ITEM = "insert-gif-modal-sticker-item";
const INSERT_GIF_MODAL_GIF_TAB = "insert-gif-modal-gif-tab";
const INSERT_GIF_MODAL_GIF_SELECTOR = "insert-gif-modal-gif-selector";
export {
  INSERT_GIF_BUTTON,
  INSERT_GIF_MODAL,
  INSERT_GIF_MODAL_GIF_ITEM,
  INSERT_GIF_MODAL_GIF_SEARCH_INPUT,
  INSERT_GIF_MODAL_GIF_SELECTOR,
  INSERT_GIF_MODAL_GIF_TAB,
  INSERT_GIF_MODAL_STICKER_ITEM,
  INSERT_GIF_MODAL_STICKER_SEARCH_INPUT,
  ROOT
};
//# sourceMappingURL=data-hooks.js.map
